import { getNationalNumber } from '../../../helpers';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  getDataSuccess: (data) => ({
    data,
  }),
  getData:
    (search, paging, sortOption = {}, filterOption = {}) =>
    async ({ Api, getState }) => {
      let pagingData = paging || getState().ca.paging;
      let { result, status } = await Api.post(`users/filter`, {
        pageIndex: pagingData.pageIndex,
        pageSize: pagingData.pageSize,
        search,
        ...sortOption,
        ...filterOption,
        roleType: 'Swabber',
      });

      if (status === 200) {
        swabberDispatcher.getDataSuccess(result);
      }
    },

  createSwabber:
    (
      {
        firstName,
        lastName,
        email,
        mobile,
        password,
        countryCode,
        lstClinicId,
      },
      search,
      callback
    ) =>
    async ({ Api }) => {
      let { status } = await Api.post(`users`, {
        firstName,
        lastName,
        email,
        password,
        mobile: getNationalNumber(mobile, countryCode),
        countryCode,
        roleType: 'Swabber',
        lstClinicId,
      });
      if (status === 200) {
        swabberDispatcher.getData(search);
        callback();
      }
    },

  deleteSwabber:
    (id) =>
    async ({ Api, customToast }) => {
      let { status } = await Api.delete(`users/${id}`);
      if (status === 200) {
        customToast('success', 'Deleted');
        swabberDispatcher.getData();
      }
    },

  updateSwabber:
    (
      { id, firstName, lastName, email, mobile, countryCode, lstClinicId },
      search,
      callback
    ) =>
    async ({ Api }) => {
      let { status } = await Api.put(`users/${id}`, {
        id,
        firstName,
        lastName,
        email,
        mobile: getNationalNumber(mobile, countryCode),
        countryCode,
        lstClinicId,
      });
      if (status === 200) {
        swabberDispatcher.getData(search);
        callback();
      }
    },
};

const swabberDispatcher = synthesize('swabber', mapDispatchToAC);
export default swabberDispatcher;
